import {AfterViewInit, Component, OnDestroy, OnInit, Query, ViewChild} from '@angular/core';
import {
  STATI_NASCOSTI_DASH_INTERVENTI,
  STILI_AREA_COMPETENZA_SEGNALAZIONI,
  STILI_STATO_INTERVENTI,
  STILI_TIPO_INTERVENTI
} from "../../../shared/stili";
import {UserService} from "../../../services/user.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Intervento_Firestore, InterventoStato} from "../../../models/firestore/interventoFirestore.model";
import {environment} from "../../../../environments/environment";
import {onSnapshot} from "firebase/firestore";
import firebase from "firebase/compat";
import {Segnalazione_Firestore} from "../../../models/firestore/segnalazioneFirestore.model";
import {ActivitiesMapWidgetComponent} from "../../../components/activities-map-widget/activities-map-widget.component";
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { StiliService } from 'src/app/services/stili.service';
import { NGXLogger } from 'ngx-logger';
import { CreaInterventoComponent } from '../../interventi/crea/crea_intervento';
import {Unsubscribe} from "firebase/app-check";

@Component({
  selector: 'app-dashboard-tecnici',
  templateUrl: './dashboard-tecnici.component.html',
  styleUrl: './dashboard-tecnici.component.scss',
  //providers: [DialogService, ConfirmationService],
})
export class DashboardTecniciComponent implements OnInit, AfterViewInit, OnDestroy {

  totals_new: number;
  totals_accepted: number;
  totals_not_done: number;
  totals_denied: number;
  totals_waiting: number;
  totals_done: number;
  totals_planned: number;

  datiInterventi: Intervento_Firestore[];
  lastChanged: Intervento_Firestore[];
  interventiMappa: Intervento_Firestore[];

  datiSegnalazioni: Segnalazione_Firestore[];

  protected readonly stiliTipoInterventi = STILI_TIPO_INTERVENTI;
  protected readonly stiliAreaCompetenzaSegnalazioni = STILI_AREA_COMPETENZA_SEGNALAZIONI;
  protected readonly stiliStatoInterventi = STILI_STATO_INTERVENTI;

  isAdmin: boolean;
  isOperatore: boolean;
  isTecnico: boolean;

  isReady: boolean;
  ref: DynamicDialogRef;

  fireUnsub: Unsubscribe[];

  @ViewChild(ActivitiesMapWidgetComponent) mapwidget: ActivitiesMapWidgetComponent;

  constructor (
    private userService: UserService,
    private firestore: AngularFirestore,
    private dialogService: DialogService,
    private messageService: MessageService,
    public stiliService:StiliService,
    private router: Router,
    private logger: NGXLogger
  ) {
   /*  this.dialogConfig = {
      height: "600px",
      width: "600px",
      disableClose: true,
      data: {},
    }; */
    this.isAdmin = this.userService.isAdmin;
    this.isOperatore = this.userService.isOperatore;
    this.isTecnico = this.userService.isTecnico;

    this.isReady = false;

    this.datiInterventi = [];
    this.lastChanged = [];
    this.datiSegnalazioni = [];
    this.interventiMappa = [];

    this.totals_denied = 0;
    this.totals_done = 0;
    this.totals_new = 0;
    this.totals_accepted = 0;
    this.totals_waiting = 0;
    this.totals_not_done = 0;
    this.totals_planned = 0;

    this.fireUnsub = [];

  }

  ngOnInit () {

  }


  ngOnDestroy() {

    console.log(`unsubscribing ${this.fireUnsub.length} firestore feeds`);
    for (let unsubscribe of this.fireUnsub) {
      unsubscribe();
    }

  }

  ngAfterViewInit () {
    this.bindLoadInterventiUltimi();
    this.bindLoadInterventiAll();
    this.bindLoadSegnalazioniAll();

    this.mapwidget.setVisibilitySegnalazioni(false);
  }

  /**
   * Caricare le segnalazioni è necessario a passare al
   */
  bindLoadSegnalazioniAll (){
    const collectionRef = this.firestore.collection(environment.firebase.collection_segnalazioni).ref;
    const unsub = onSnapshot(collectionRef, (qs) => {
       this.datiSegnalazioni = qs.docs.map((item) => {
        return item.data() as Segnalazione_Firestore;
      });
    });

    this.fireUnsub.push(unsub);

  }


  calcolaInterventiStato(){
   // console.log("* calcolaStats", segnalazioni.length);
    this.totals_denied = 0;
    this.totals_done = 0;
    this.totals_new = 0;
    this.totals_accepted = 0;
    this.totals_waiting = 0;
    this.totals_not_done = 0;
    this.totals_planned = 0;
    this.datiInterventi.forEach((item) => {
       switch (item.stato) {
         case InterventoStato.CREATED:
           this.totals_new++;
           break;
         case InterventoStato.NOT_DONE:
           this.totals_not_done++;
           break;
         case InterventoStato.DONE:
           this.totals_done++;
           break;
         case InterventoStato.PLANNED:
           this.totals_planned++;
           break;
         case InterventoStato.SUSPENDED:
           this.totals_waiting++;
           break;
       }
    });
    this.isReady = true;
  }


  bindLoadInterventiAll (){

    const utente = this.userService.getUser();
    const collectionRef = this.firestore.collection(environment.firebase.collection_interventi).ref;
    const query = collectionRef.where("stato", "not-in", STATI_NASCOSTI_DASH_INTERVENTI);
    const unsub = onSnapshot(query, (qs) => {
       this.datiInterventi = qs.docs.map((item) => {
        return item.data() as Intervento_Firestore;
      }).filter((item) => {
          if (this.isTecnico && !((item.tecnici ?? []).some((value) => { return value.id == utente.id;}))) {
            return false;
          } else {
            return true;
          }
       });
       this.interventiMappa = [...this.datiInterventi];

      this.calcolaInterventiStato();
      // this.updateSegnalazioni();
    });

    this.fireUnsub.push(unsub);

  }


  bindLoadInterventiUltimi () {

    const collectionRef = this.firestore.collection(environment.firebase.collection_interventi).ref;
    let query = collectionRef.orderBy('modificato', 'desc');

    const utente = this.userService.getUser();

    const unsub = onSnapshot(query, (qs) => {
      const interventiTecnico = qs.docs.map((item) => {
        return item.data() as Intervento_Firestore;
      }).filter((item) => {
          if (this.isTecnico && !((item.tecnici ?? []).some((value) => { return value.id == utente.id;}))) {
            return false;
          } else {
            return true;
          }
       });
      this.lastChanged = interventiTecnico.length > 5 ? interventiTecnico.slice(interventiTecnico.length - 5) : interventiTecnico;
    });

    this.fireUnsub.push(unsub);

  }

  openInterventi(){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['interventi']));

  }

  openInterventiConStato(stato:String){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['interventi/stato/'+stato]));
  }

  openIntervento(row)  {
     this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['interventi/intervento/'+row.codice]));
  }

}
